// extracted by mini-css-extract-plugin
export default {"container":"LFt4o","title":"Hi348","titleThin":"N5QPM","titleAbsolute":"NcpAT","text":"QSx91","aboutContainer":"DOemP","aboutTitle":"Fk1dF","skeleton-progress":"_62Hs6"};